// funkcinalita pro práci s URL adresami

export function getServerUrl() {
  if (window.location.hostname === "localhost") {
    return "http://localhost:44350";
  } else if (window.location.hostname === "test.triferis.sk") {
    return "https://testapi.triferis.sk";
  } else if (window.location.hostname === "triferis.sk") {
    return "https://api.triferis.sk";
  } else {
    return "";
  }
}

export const API_BASE_URL = getServerUrl() + "/api";

export const LOGIN_URL = getServerUrl() + "/api/login";

export const REGISTER_URL = getServerUrl() + "/api/register";

export const FORGOT_PASSWORD_URL = getServerUrl() + "/api/forgot-password";

export const IS_AUTHENTICATED_URL = getServerUrl() + "/api/is-authenticated";

export const ERROR_LOG_URL = getServerUrl() + "/api/errorlog";

export const VERIFY_EMAIL_URL = getServerUrl() + "/api/verify-email";

export const RESEND_VERIFICATION_URL =
  getServerUrl() + "/api/resend-verification";

export const FRONTEND_ERROR_LOG_URL = getServerUrl() + "/api/frontend-errorlog";

export const GET_USERS_URL = getServerUrl() + "/api/users";

export const VERIFY_USER_URL = getServerUrl() + "/api/user/verify";

export const DELETES_USER_URL = (id) => getServerUrl() + `/api/users/${id}`;

export const UPDATE_USER_URL = getServerUrl() + "/api/updateUser";

// Stripe & Platby kartou
export const CREATE_PAYMENT_INTENT_URL = getServerUrl() + "/api/create-payment-intent";
export const REFUND_PAYMENT_URL = getServerUrl() + "/api/refund";
export const REFUND_SUBSCRIPTION_URL = getServerUrl() + "/api/refund";
export const REQUEST_REFUND_URL = getServerUrl() + "/api/request-refund";
export const BLOCKED_PAYMENTS_URL = getServerUrl() + "/api/blocked-payments";
export const RECEIPT_DOWNLOAD_URL = (filename) => getServerUrl() + `/api/receipts/${filename}`;
export const REFUND_DOWNLOAD_URL = (filename) => getServerUrl() + `/api/refunds/${filename}`;

// trainings & events
export const TRAININGS_PERIOD_URL = getServerUrl() + "/api/events/period";
export const MY_CHILDREN_EVENTS_URL = getServerUrl() + "/api/events/my-children-events";
export const CANCEL_LESSON_URL = getServerUrl() + "/api/events/cancel-lesson";
export const LESSON_CANCELLATIONS_URL = getServerUrl() + "/api/lesson-cancellations";
export const UPDATE_LESSON_CANCELLATION_URL = (id) => getServerUrl() + `/api/lesson-cancellations/${id}`;

// profile
export const PROFILE_URL = getServerUrl() + "/api/profile";
export const CHANGE_PASSWORD_URL = getServerUrl() + "/api/change-password";

// contact form
export const CONTACT_URL = getServerUrl() + "/api/send-contact-email";

// bulk email (admin)
export const SEND_BULK_EMAIL_URL = getServerUrl() + "/api/send-bulk-email";

// číselníky (admin & user)
export const CREDITS_URL = getServerUrl() + "/api/credits";
export const MY_CREDITS_URL = getServerUrl() + "/api/my-credits";
export const PERSONS_URL = getServerUrl() + "/api/persons";
export const MY_PERSONS_URL = getServerUrl() + "/api/my-persons";
export const SCHOOLS_URL = getServerUrl() + "/api/schools";
export const PUBLIC_SCHOOLS_URL = getServerUrl() + "/api/schools/public";
export const PRODUCT_CATALOG_URL = getServerUrl() + "/api/product-catalog";

// Verejný katalóg členstiev / produktov
export const PUBLIC_PRODUCT_CATALOG_URL = getServerUrl() + "/api/product-catalog/public";
export const PUBLIC_KATALOG_CLENSTIEV_URL = getServerUrl() + "/api/katalog-clenstiev/public";

// Platby a Objednávky
export const TRANSFER_PAYMENT_URL = getServerUrl() + "/api/payments/transfer";
export const MY_ORDERS_URL = getServerUrl() + "/api/orders/my-orders";
export const ORDER_DETAILS_URL = (id) => getServerUrl() + `/api/orders/${id}`;

// Rozhranie Lektora
export const LEKTOR_COURSES_URL = getServerUrl() + "/api/lektor/courses";
export const LEKTOR_COURSE_PARTICIPANTS_URL = (courseId) => getServerUrl() + `/api/lektor/courses/${courseId}/participants`;
export const LEKTOR_COURSE_LESSONS_URL = (courseId) => getServerUrl() + `/api/lektor/courses/${courseId}/lessons`;
export const LEKTOR_SEND_EMAIL_URL = getServerUrl() + "/api/lektor/send-email";
export const LEKTOR_ATTENDANCE_URL = getServerUrl() + "/api/lektor/attendance";
export const LEKTOR_CANCEL_LESSON_URL = getServerUrl() + "/api/lektor/lessons/cancel";
export const LEKTOR_SEED_DATA_URL = getServerUrl() + "/api/lektor/seed-data";

// Bankové údaje OZ pre prevod
export const getBankDetails = () => ({
  iban: process.env.REACT_APP_BANK_IBAN || "SK8383300000002003415841",
  swift: process.env.REACT_APP_BANK_SWIFT || "FIOZSKBAXXX",
  bankName:
    process.env.REACT_APP_BANK_NAME ||
    "Fio banka, a. s., pobočka zahraničnej banky, Dunajská 1, 81108 Bratislava - mestská časť Staré mesto",
  recipientName: process.env.REACT_APP_BANK_RECIPIENT_NAME || "Kvalitná škola o.z.",
  constantSymbol: process.env.REACT_APP_BANK_CONSTANT_SYMBOL || "0308",
});

// Hodnota 1 kreditu v EUR (1 kredit = X EUR) - musí byť zhodná s backend/.env CREDIT_VALUE_EUR
export const CREDIT_VALUE_EUR = parseFloat(process.env.REACT_APP_CREDIT_VALUE_EUR);

// Aliases pre spätnú kompatibilitu
export const KREDITY_URL = CREDITS_URL;
export const OSOBY_URL = PERSONS_URL;
export const KATALOG_PRODUKTOV_URL = PRODUCT_CATALOG_URL;
export const KATALOG_CLENSTIEV_URL = PRODUCT_CATALOG_URL;

export const UPLOADS_URL = getServerUrl();



